module.exports = __webpack_public_path__ + "img/406.49619038.png";